import * as React from "react";
import type { SVGProps } from "react";
const SvgDragdropIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="dragdrop_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M384 298.667A85.333 85.333 0 1 0 384 128a85.333 85.333 0 0 0 0 170.667zm256 0A85.333 85.333 0 1 0 640 128a85.333 85.333 0 0 0 0 170.667zM469.333 512a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 597.333a85.333 85.333 0 1 0 0-170.666 85.333 85.333 0 0 0 0 170.666zM469.333 810.667a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 896a85.333 85.333 0 1 0 0-170.667A85.333 85.333 0 0 0 640 896z"
    />
  </svg>
);
export default SvgDragdropIcon;
